export default {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVE: 'ARCHIVE',
} as const
